import React from "react";
import "./Restaurant.css";
import WaitingFor from "components/Banner/WaitingFor";

// Images
import Restaurant from "images/goopter-use-case-restaurant.jpg";
import Process from "images/restaurant/goopter-ecommerce-restaurant-ordering-process.png";
import Highlights from "images/restaurant/goopter-ecommerce-ordering-highlights.jpg";
// Background Images
import { ReactComponent as LeftBox } from "images/background/left-box-graphic.svg";
import { ReactComponent as RightBox } from "images/background/right-box-graphic.svg";
import { Link } from "react-router-dom";
import OtherUseCases from "components/Banner/UsecasesBanner";

import { FormattedMessage } from "react-intl";
import VimeoComponent from "components/Vimeo/VimeoComponent";

// Video
const video = {
  videoUrl: "https://player.vimeo.com/video/671246520?h=1a8b91dc7c",
};

export default function Index() {
  return (
    <>
      <div className="restaurant-page">
        <section className="banner">
          <div className="image-box">
            <img
              src={Restaurant}
              className="restaurant-img"
              alt="goopter use case restaurant"
            />

            <div className="col-lg-12 text-box">
              <div className="col-lg-5 col-sm-12 left-title">
                {/* <h1>We help restaurants simplify and automate their ordering.</h1> */}
                <h1>
                  <FormattedMessage
                    id={"use_case_restaurant_page_header_title"}
                  />
                </h1>
              </div>
              <div className="col-lg-7 col-sm-12 right-text">
                <p className="desc1">
                  <FormattedMessage id={"usecase_restaurant_ordering_text1"} />
                </p>
                <p className="desc2">
                  <FormattedMessage id={"usecase_restaurant_ordering_text2"} />
                </p>
              </div>
            </div>
          </div>
        </section>
        <div className="main-background">
          <section className="introduction container row mx-auto">
            <div className="col-lg-12 video-wrapper">
              <VimeoComponent videoUrl={video.videoUrl} paused={false} />
            </div>
            <div className="col-lg-12 intro-box">
              <p className="desc1">
                <FormattedMessage
                  id={"use_case_restaurant_page_header_text1"}
                />
              </p>
              <p className="desc2">
                <FormattedMessage
                  id={"use_case_restaurant_page_header_text2"}
                />
              </p>
            </div>
          </section>
          <section className="goopter-restaurant row mx-auto">
            <RightBox className="right-bg" />
            <LeftBox className="left-bg" />
            <div className="col-lg-12 intro-box">
              <h2 className="desktop">
                <FormattedMessage id={"use_case_restaurant_page_intro_title"} />
              </h2>
              <h2 className="mobile">
                <FormattedMessage id={"use_case_restaurant_page_intro_title"} />
              </h2>
              <div className="img-box col-lg-9">
                <img src={Process} alt="ordering automation" />
              </div>
            </div>
          </section>
          <section className="highlights container row mx-auto">
            <h2>
              <FormattedMessage id={"highlights_of_the_features"} />
            </h2>
            <div className="col-lg-12 contents">
              <div className="col-lg-6 col-sm-12 left-box">
                <h5>
                  <FormattedMessage
                    id={"use_case_restaurant_page_highlights1_title"}
                  />
                </h5>
                <p>
                  <FormattedMessage
                    id={"use_case_restaurant_page_highlights1_text"}
                  />
                </p>
                <h5>
                  <FormattedMessage
                    id={"use_case_restaurant_page_highlights2_title"}
                  />
                </h5>
                <p>
                  <FormattedMessage
                    id={"use_case_restaurant_page_highlights2_text"}
                  />
                </p>
                <h5>
                  <FormattedMessage
                    id={"use_case_restaurant_page_highlights3_title"}
                  />
                </h5>
                <p>
                  <FormattedMessage
                    id={"use_case_restaurant_page_highlights3_text"}
                  />
                </p>
                <div className="btn green-button">
                  <Link to="/request-a-demo">
                    <FormattedMessage id={"learn_more"} />
                  </Link>
                </div>
              </div>
              <div className="col-lg-6 col-sm-12 right-box">
                <img src={Highlights} alt="ordering highlights" />
              </div>
            </div>
          </section>
          <OtherUseCases except="Restaurant Ordering" />
        </div>
        <WaitingFor />
      </div>
    </>
  );
}
